// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3326":"9ac8ad22","4101":"7d75f0f4"}[chunkId] + ".chunk.css";
};